import service from "@/utils/request"

/**
 * 获取待审核商品列表
 * @param data 分页参数和筛选条件
 * @returns {*}
 */
export function getPendingReviewListApi(data) {
    return service({
        url: '/chooseGoodsManagement/getReviewedSjGoodsList',
        method: 'get',
        params: data
    })
}

/**
 * 获取已审核商品列表
 * @param data 分页参数和筛选条件
 * @returns {*}
 */
export function getReviewedListApi(data) {
    return service({
        url: '/chooseGoodsManagement/getReviewedSjGoodsList',
        method: 'get',
        params: data
    })
}

/**
 * 审核通过商品
 * @param data 包含商品ID和状态的参数
 * @returns {*}
 */
export function approveGoodsApi(data) {
    return service({
        url: '/sjGoods/updateStatus',
        method: 'get',
        params: data
    })
}

/**
 * 审核拒绝商品
 * @param data 包含商品ID和状态的参数
 * @returns {*}
 */
export function rejectGoodsApi(data) {
    return service({
        url: '/sjGoods/updateStatus',
        method: 'get',
        params: data
    })
}

/**
 * 撤回已审核商品
 * @param data 包含商品ID和状态的参数
 * @returns {*}
 */
export function revokeGoodsApi(data) {
    return service({
        url: '/sjGoods/updateStatus',
        method: 'get',
        params: data
    })
}

/**
 * 撤回商品审核状态
 * @param data 包含商品ID和状态的参数
 * @returns {*}
 */
export function withdrawGoodsApi(data) {
    return service({
        url: '/sjGoods/updateStatus',
        method: 'get',
        params: data
    })
}